import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Activity as ActIcon } from "lucide-react";
import { EmptyState, PageLoading, PageHeader, fmtDateTime } from "@/components/shared";
import api from "@/lib/api";

export default function AdminActivity() {
  const { t } = useTranslation();
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/activity").then((r) => setItems(r.data.activity)); }, []);
  if (items === null) return <PageLoading />;
  return (
    <div data-testid="admin-activity">
      <PageHeader title={t("adm.acTitle")} subtitle={t("adm.acSubtitle")} />
      {items.length === 0 ? <EmptyState icon={ActIcon} title={t("adm.acEmpty")} /> : (
        <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white divide-y divide-slate-50">
          {items.map((a) => (
            <div key={a.id} className="flex items-start gap-3 px-4 py-3.5">
              <div className="mt-0.5 flex h-8 w-8 items-center justify-center rounded-full bg-slate-100 text-slate-500"><ActIcon className="h-4 w-4" /></div>
              <div className="flex-1"><div className="text-sm font-semibold capitalize text-navy">{a.action.replace(/[._]/g, " ")}</div><div className="text-xs text-slate-400">{a.actor_email} {a.employee_name ? `· ${a.employee_name}` : ""}</div></div>
              <div className="text-xs text-slate-400">{fmtDateTime(a.created_at)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
